export default "__VITE_ASSET__DXL7YZQv__"